import { format, parseISO } from 'date-fns';
import { StringHelpers } from 'devyx-ui';

interface IComponentProps {
  value: any;
  // eslint-disable-next-line react/no-unused-prop-types
  withHour?: boolean;
  interval?: 'month' | 'year';
}

export function DateColumnFormatter({
  value,
  withHour = false,
}: {
  value: string | null;
  withHour?: boolean;
}): JSX.Element {
  return !withHour ? (
    value ? (
      <span style={{ justifyContent: 'flex-start' }}>
        {format(parseISO(value), 'dd/MM/yyyy')}
      </span>
    ) : (
      <span>-</span>
    )
  ) : value ? (
    <span style={{ justifyContent: 'flex-start' }}>
      {format(parseISO(value), "dd/MM/yyyy 'às' HH:mm")}
    </span>
  ) : (
    <span>-</span>
  );
}

DateColumnFormatter.defaultProps = {
  withHour: false,
};

export function PriceColumnFormatter({
  value,
  interval,
}: IComponentProps): JSX.Element {
  if (!value.length) return <>-</>;

  const price = value
    .filter((el: any) => el.is_active)
    .find((el: any) => el.interval === interval)?.unit_amount_decimal;

  return price ? <>{StringHelpers.formatCurrency(price)}</> : <>-</>;
}
